{
  "valid": "תָקֵף"
}
